import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetVideoResponseBody } from '../VideosApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseVideoQueryValues = {
  appId: string;
  videoId: string;
};

export const videoQueryKeyFactory: IQueryKeyFactory<IUseVideoQueryValues> = (
  values,
) => values && (['video', values.appId, values.videoId] as const);

export const useVideoQuery = (
  values?: IUseVideoQueryValues,
  options?: UseQueryOptions<IApiGetVideoResponseBody, ApiError>,
): UseQueryResult<IApiGetVideoResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: videoQueryKeyFactory(values),
    queryFn: values
      ? () => api.videos.get(values.appId, values.videoId)
      : undefined,
    enabled: !!values,
    retry: options?.retry ?? 1,
    retryDelay: options?.retryDelay ?? 500,
    ...options,
  });
};
